export default "__VITE_ASSET__CL3PXca2__"